module.exports = __webpack_public_path__ + "static/media/temp-mother.0c217bf0.jpg";